import { VerbaScholaApi } from '../api/VerbaScholaApi';

export type StudentActivityEvent = 'model_audio_play' | 'content_audio_play' | 'pronunciation_detail_open' | 'short_microphone_hold' | 'activity_exit';

/** Best-effort diagnostic event; it never controls student progress or preview. */
export function recordStudentActivity(event: StudentActivityEvent, durationMs?: number): void {
    const match = window.location.pathname.match(/^\/student\/course\/\d+\/lesson\/\d+\/step\/(\d+)$/);
    if (!match) return;
    void VerbaScholaApi.recordStudentActivity(Number(match[1]), event, durationMs).catch(() => undefined);
}
